import * as React from "react";
function AspectOriginalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    fill: "none",
    viewBox: "0 0 17 11",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.977 10.133c.565 0 .945-.38.945-.958V1.773c0-.66-.406-1.072-1.085-1.072-.394 0-.698.057-1.143.362L.88 2.319c-.298.21-.413.426-.413.718 0 .406.286.685.673.685a.78.78 0 00.508-.171l1.34-.933h.037v6.557c0 .577.388.958.953.958zm5.25-5.903c.564 0 1.021-.457 1.021-1.022 0-.571-.457-1.022-1.022-1.022-.571 0-1.022.45-1.022 1.022 0 .565.45 1.022 1.022 1.022zm0 4.539c.564 0 1.021-.457 1.021-1.022 0-.572-.457-1.022-1.022-1.022-.571 0-1.022.45-1.022 1.022 0 .565.45 1.022 1.022 1.022zm6.785 1.364c.565 0 .945-.38.945-.958V1.773c0-.66-.406-1.072-1.085-1.072-.393 0-.698.057-1.143.362l-1.815 1.256c-.298.21-.412.426-.412.718 0 .406.285.685.672.685a.78.78 0 00.508-.171l1.34-.933h.038v6.557c0 .577.387.958.952.958z"
  }));
}
const ForwardRef = React.forwardRef(AspectOriginalIcon);
export default ForwardRef;